import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat'
})
export class PhoneNumberFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!!value && value.indexOf(',') > -1) {
      let valArr = value.split(',');
      for (let i = 0; i < valArr.length; i++) {
        let phoneNumber: string = valArr[i].trim().replace(/[^0-9]/g, '');
        if (phoneNumber.length >= 10) {
          phoneNumber = `(${phoneNumber.substr(0, 3)} ${phoneNumber.substr(3, 3)}-${phoneNumber.substr(6)}`;
        }
        valArr[i] = phoneNumber;
      }
      return valArr.join(', ');
    } else if (value != null && value.length >= 10) {
      let phoneNumberStripped = value.replace(/[^0-9]/g, '');
      return '(' + phoneNumberStripped.substr(0, 3) + ') ' + phoneNumberStripped.substr(3, 3) + '-' + phoneNumberStripped.substr(6, 4);
    }
    else {
      return value;
    }
  }

}
